export default "__VITE_ASSET__e3c59991__"